import React from 'react';
import { Row } from 'react-bootstrap';

import Section from '../../shared/Section';

export default function SectionCard({ title, children }) {
  return (
    <Section Title={title}>
      <Row className="mt-3">{children}</Row>
    </Section>
  );
}
